import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventType } from '../../constants';
import { GATrackingEventPayload } from '~shared/modules/ga-tracking/models';
import { EcommerceApplicationEventPayload } from '~shared/models';

export class GATrackingBeginCheckoutEvent implements GATrackingEvent {
  constructor(private beginCheckoutApplicationEvent: EcommerceApplicationEventPayload) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.BeginCheckout;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ...this.beginCheckoutApplicationEvent,
      },
    };
  }
}
